// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58b9a0cb","455":"cefbc351","977":"5d7b8c6d"}[chunkId] + ".chunk.js";
};